module.exports = __webpack_public_path__ + "static/img/18013B_3_4_C_20230519_LC.d94f841.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/18013B_3_4_C_20230519_LC.png
// module id = 0yjM
// module chunks = 0